module.exports = __webpack_public_path__ + "static/cover-abruzzo-0a6cd4290765d89184e3ccca87fe552c.jpg";